import { ProductKeys, type ProductKeys1P } from '../../../../../common/constants/products';
import { createBooleanFilter } from '../../../../filters/boolean-filter';

const productKeys1P: ProductKeys1P[] = [ProductKeys.Compass];

export const filter = createBooleanFilter({
	id: 'compassArchived',
	queryParams: { key: 'compassArchived' },
	products: productKeys1P,
	alwaysVisible: true,
	universal: false,
});
